import React from "react"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap"
import { useTranslation } from "react-i18next"

interface CustomerInfoProps {
  openAccordion: any
  setOpenAccordion: any
  order: any
}
const CustomerInfo = ({
  openAccordion,
  setOpenAccordion,
  order,
}: CustomerInfoProps) => {
  const { t } = useTranslation()
  return (
    <Accordion
      open={openAccordion.customerInfo}
      className="border-0 bg-semi-white order-item"
    >
      <AccordionItem>
        <AccordionHeader
          className="font-size-16 text-semi-dark fw-semibold mx-2"
          targetId="0"
          onClick={() =>
            setOpenAccordion({
              ...openAccordion,
              customerInfo: openAccordion.customerInfo === "0" ? "1" : "0",
            })
          }
        >
          {t("orders_customerInfo")}
        </AccordionHeader>
        <AccordionBody accordionId="0">
          <Row>
            <Col sm="6">
              <Card className="shadow-md">
                <CardBody className="p-2">
                  <p className="mb-0">
                    <span className="text-muted text-12px">
                      {t("common_createdBy")}
                    </span>
                  </p>
                  <div className="d-flex space-between ">
                    <div>
                      <img
                        src={order.createdBy.image}
                        alt=""
                        className="rounded-circle"
                      />
                    </div>
                    <div className="p-2 w-100 d-flex flex-column justify-content-between">
                      <div>
                        <p className="mb-0">
                          <span className="font-size-16 text-semi-dark fw-semibold ">
                            {order.createdBy.name}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-light btn-md rounded-circle p-2 bg-success text-white flex"
                        style={{ width: "35px", height: "35px" }}
                      >
                        <i className="bx bx-phone bx-xs" />
                      </button>
                      <button
                        className="btn bg-white text-success btn-md rounded-circle p-2"
                        style={{
                          width: "35px",
                          height: "35px",
                          border: "1px solid #27AE60 !important",
                        }}
                      >
                        <i className="bx bx-message bx-xs" />
                      </button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col sm="6">
              <Card className="shadow-md">
                <CardBody className="p-2">
                  <p className="mb-0">
                    <span className="text-muted text-12px">
                      {t("orders_shippingAddress")}
                    </span>
                  </p>
                  <div className="d-flex space-between ">
                    <div className="p-2 w-100 d-flex flex-column justify-content-between">
                      <div>
                        <p className="mb-0">
                          <i className="dripicons-location" />
                          <span className="font-size-16 text-semi-dark fw-semibold px-2">
                            {order.address}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  )
}

export default CustomerInfo
